/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SupplementalGetReportFormInstancesByFilterResponseResultsInner } from './SupplementalGetReportFormInstancesByFilterResponseResultsInner';
import {
    SupplementalGetReportFormInstancesByFilterResponseResultsInnerFromJSON,
    SupplementalGetReportFormInstancesByFilterResponseResultsInnerFromJSONTyped,
    SupplementalGetReportFormInstancesByFilterResponseResultsInnerToJSON,
} from './SupplementalGetReportFormInstancesByFilterResponseResultsInner';

/**
 * 
 * @export
 * @interface SupplementalGetReportFormInstancesByFilterResponse
 */
export interface SupplementalGetReportFormInstancesByFilterResponse {
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetReportFormInstancesByFilterResponse
     */
    count?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetReportFormInstancesByFilterResponse
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetReportFormInstancesByFilterResponse
     */
    next?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SupplementalGetReportFormInstancesByFilterResponse
     */
    previous?: number | null;
    /**
     * 
     * @type {Array<SupplementalGetReportFormInstancesByFilterResponseResultsInner>}
     * @memberof SupplementalGetReportFormInstancesByFilterResponse
     */
    results?: Array<SupplementalGetReportFormInstancesByFilterResponseResultsInner>;
}

/**
 * Check if a given object implements the SupplementalGetReportFormInstancesByFilterResponse interface.
 */
export function instanceOfSupplementalGetReportFormInstancesByFilterResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SupplementalGetReportFormInstancesByFilterResponseFromJSON(json: any): SupplementalGetReportFormInstancesByFilterResponse {
    return SupplementalGetReportFormInstancesByFilterResponseFromJSONTyped(json, false);
}

export function SupplementalGetReportFormInstancesByFilterResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupplementalGetReportFormInstancesByFilterResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(SupplementalGetReportFormInstancesByFilterResponseResultsInnerFromJSON)),
    };
}

export function SupplementalGetReportFormInstancesByFilterResponseToJSON(value?: SupplementalGetReportFormInstancesByFilterResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'limit': value.limit,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(SupplementalGetReportFormInstancesByFilterResponseResultsInnerToJSON)),
    };
}

